export type ItemsReportPreset = 'today' | 'yesterday' | 'last7' | 'custom';

export const ITEMS_REPORT_PRESETS: Array<{ value: ItemsReportPreset; label: string }> = [
  { value: 'today', label: 'היום' },
  { value: 'yesterday', label: 'אתמול' },
  { value: 'last7', label: '7 ימים' },
  { value: 'custom', label: 'בחירת תאריכים' },
];

const pad = (value: number): string => String(value).padStart(2, '0');

export const toDateInput = (value: Date): string =>
  `${value.getFullYear()}-${pad(value.getMonth() + 1)}-${pad(value.getDate())}`;

const shiftDays = (days: number): Date => {
  const date = new Date();
  date.setDate(date.getDate() + days);
  return date;
};

// Ranges are inclusive day bounds matched against each shift's OPENING day.
export const rangeForPreset = (preset: Exclude<ItemsReportPreset, 'custom'>): { from: string; to: string } => {
  if (preset === 'yesterday') {
    const yesterday = toDateInput(shiftDays(-1));
    return { from: yesterday, to: yesterday };
  }
  if (preset === 'last7') {
    return { from: toDateInput(shiftDays(-7)), to: toDateInput(new Date()) };
  }
  const today = toDateInput(new Date());
  return { from: today, to: today };
};

export const formatRangeLabel = (from: string, to: string): string => {
  const asDay = (value: string): string => value.split('-').reverse().join('.');
  return from === to ? asDay(from) : `${asDay(from)} - ${asDay(to)}`;
};
